import React, { useEffect } from "react";
import { FiHome, FiPlusCircle, FiMenu, FiUser, FiSearch, FiMonitor } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";

export default function UserLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: FiHome, label: "Home", path: "/" },
    { icon: FiPlusCircle, label: "Add", path: "/user/add-business" },
    { icon: FiMonitor, label: "Learn", path: "/videos" },
    { icon: FiMenu, label: "More", path: "/user/profile" },
  ];

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/" || location.pathname === "/user/home";
    // For other paths, exact match or startswith
    return location.pathname === path || (path !== "/" && location.pathname.startsWith(path));
  };

  return (
    <div className="relative min-h-screen pb-[60px] bg-gray-50">
      {children}

      {/* 📱 STANDARD BOTTOM NAVIGATION */}
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 z-50 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] safe-area-pb">
        <div className="flex justify-around items-center h-16 max-w-7xl mx-auto">
          {navItems.map((item, index) => {
            const active = isActive(item.path);

            return (
              <div
                key={index}
                onClick={() => {
                  if (item.path.startsWith("/")) navigate(item.path);
                }}
                className="flex flex-col items-center justify-center w-full h-full cursor-pointer active:bg-gray-50 transition-colors"
              >
                <item.icon
                  size={24}
                  className={`mb-1 transition-colors duration-200 ${active ? 'text-blue-600' : 'text-gray-400'}`}
                  strokeWidth={active ? 2.5 : 2}
                />
                <p
                  className={`text-[10px] font-medium transition-colors duration-200 ${active ? 'text-blue-600' : 'text-gray-500'}`}
                >
                  {item.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
